import { FC, ReactNode } from 'react';
import { motion } from 'framer-motion';

interface Props {
  children: ReactNode;
}

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12 },
  },
};

const panelVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring' as const, stiffness: 260, damping: 24 },
  },
};

const CheckoutLayout: FC<Props> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-5xl px-4 py-8">
        <motion.div
          className="grid md:grid-cols-[1fr_2fr] gap-6 items-start"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {Array.isArray(children)
            ? children.map((child, i) => (
                <motion.div key={i} variants={panelVariants}>
                  {child}
                </motion.div>
              ))
            : <motion.div variants={panelVariants}>{children}</motion.div>}
        </motion.div>
      </div>
    </div>
  );
};

export default CheckoutLayout;
